import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const calculateBillingRateApi = createApi({
    reducerPath: 'calculateBillingRateApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['calculateBillingRate'],
    endpoints: builder => ({
        calculateBillingRate: builder.mutation({
            query: body => {
                return {
                    url: spotFinder.calculateBillingRateController.calculateBillingRate,
                    method: 'POST',
                    body: body.payload,
                    // headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        saveAuditLog: builder.mutation({
            query: body => {
                return {
                    url: spotFinder.calculateBillingRateController.saveAuditLog,
                    method: 'POST',
                    body: body.payload,
                    // headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        applyCoupon: builder.mutation({
            query: body => {
                return {
                    url: `${spotFinder.calculateBillingRateController.applyCoupon}/${body.offerId}/${body.amount}`,
                    method: 'GET',
                    //body: body.payload,
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        calculateExtraBillingRate: builder.mutation({
            query: body => {
                return {
                    url: spotFinder.calculateBillingRateController.calculateExtraBillingRate,
                    method: 'POST',
                    body: body.payload,
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                };
            },
        }),
    }),
});

export const { useCalculateBillingRateMutation, useApplyCouponMutation, useSaveAuditLogMutation,useCalculateExtraBillingRateMutation,
} = calculateBillingRateApi;